import React, { useState } from "react";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { returnColor } from "src/helpers/helperFunctions";
import { ICompletedVitals } from "src/types/GlobalInterfaces";
import SingleBioMarkerHistory from "../GlobalComponents/HealthProfiles/SingleBioMarkerHistory";

interface IProps {
  item: ICompletedVitals;
  uid: string;
  dob: string;
  gender: string;
  onSuccess: () => void;
  index: number;
}

const CompletedVitalComponent: React.FC<IProps> = ({
  item,
  dob = "",
  gender = "",
  uid = "",
  onSuccess = () => {},
  index = 0,
}) => {
  const [selectedId, setSelectedId] = useState<string>("");

  return (
    <div>
      <div className="biomarker-new-ui biomarker-grid-pending">
        <div className="w-full">
          <span className="font-size-18px text-white font-Poppins-Regular truncate w-full block">
            {item?.name || ""}
          </span>
        </div>
        <div className="flex justify-center">
          <span
            style={{ background: returnColor(item?.biomarkerColour) }}
            className="new-biomarker-btn min-w-[98%] w-fit whitespace-nowrap mx-auto text-center font-size-15px font-Poppins-Regular text-white"
          >
            {`${item.value} ${item?.measurement || ""}`}
          </span>
        </div>
        <div className="flex justify-center">
          <p className="font-size-15px text-white font-Poppins-Regular">
            {moment(item?.date).format("DD MMM YYYY")}
          </p>
        </div>
        <div className="flex justify-center">
          <FontAwesomeIcon
            onClick={() => setSelectedId(selectedId ? "" : item?._id)}
            className="cursor-pointer text-white"
            icon={selectedId === item?._id ? faChevronUp : faChevronDown}
            size="sm"
            id={`vital-show-hide-btn-${item?.name}`}
          />
        </div>
      </div>
      {selectedId === item?._id && (
        <div className={`new-health-vitals-dropdown`}>
          <SingleBioMarkerHistory
            uid={uid}
            _date={dob}
            _gender={gender}
            bioId={item?._id}
            onSuccess={onSuccess}
            isCustomer={true}
            index={index + 1000}
            customId={`${item?.name}`}
          />
        </div>
      )}
    </div>
  );
};

export default CompletedVitalComponent;
